module.exports = __webpack_public_path__ + "static/img/4.c2ec894.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/sp/4.png
// module id = vwwZ
// module chunks = 0